module.exports = __webpack_public_path__ + "img/logo.5d5f69d4.png";